module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"video_upload_error":{"default":"影片上傳失敗。","too_large":"影片最大可上傳至500MB。","invalid_type":"檔案格式非影片。"},"video_create_error":{"default":"影片上傳過程中發生錯誤。"}}}')
  delete Component.options._Ctor
}
